export default __webpack_public_path__ + "static/media/github.bb6a55ff.jpg";